import ja from "../lang/ja.json";
const langJson = ja;
export const gettext = (id) => {
    let res = id;
    if (langJson[id]) {
        if (langJson[id][0] == null) {
            res = langJson[id][1];
        }
        else {
            res = langJson[id][1][0];
        }
    }
    return res;
};
export const __ = gettext;
